import React from 'react'

const Thirty_eight = () => {
    return (
        <div className='container'>
            <h1>C Program to Merge the Elements of 2 Sorted Array</h1>
            <p>
            This problem will implement two one-dimentional arrays and will sort them 
            separately. Then these sorted arrays are merged into one single sorted array. <br />
           </p>
            <h3>Problem Solution</h3>
            1. Create two arrays of some fixed size and define their elements in sorted fashion. <br />
2. Take two variables i and j, which will be at the 0th position of these two arrays. <br />
3. Elements will be compared one by one using i and j in for loop, and whichever element is smaller than the other, that element will get inserted to final array and the position(either i or j) will move by one, whereas the other array’s track position will remain in that same place. <br />
4. Above work will be done till we reach the end of either array. After that, one of the array whose elements are still to be added, its elements will get straightaway added to the final array <br />
      
      <div className='containers'>
          
  <code className='library'>  #include</code> &lt;stdio.h&gt; <br/>
  <code className='keywords'>  void </code> main()<br/>
    &#123; <br/>
 <br/>
 <code className='library'> int </code> array1[50], array2[50], array3[100], m, n, i, j, k = 0;<br/>
 <code className='library'> printf</code>("\n Enter size of array Array 1: ");<br/>
 <code className='library'> scanf</code>("%d", &m);<br/>
 <br/>
 <code className='keywords'>  printf </code>("\n Enter sorted elements of array 1: \n");<br/>
 <code className='keywords'> for </code> (i = 0; i &lt; m; i++) <br/>
        &#123; <br/>
        <code className='library'> scanf</code>("%d", &array1[i]);<br/>
        &#125; <br/>
 <br/>
 <code className='library'>  printf</code>("\n Enter size of array 2: ");<br/>
 <code className='library'>  scanf</code>("%d", &n);<br/>
 <br/>
 <code className='library'>  printf</code>("\n Enter sorted elements of array 2: \n");<br/>
 <code className='keywords'>  for </code>(i = 0; i &lt; n; i++) <br/>
        &#123; <br/>
        <code className='library'>     scanf</code>("%d", &array2[i]);<br/>
        &#125;<br/>
 <br/>
        i = 0;<br/>
        j = 0;<br/>
 <br/>
 <code className='keywords'> while</code> (i &lt; m && j &lt; n) <br/>
        &#123; <br/>
        <code className='keywords'>    if </code> (array1[i] &lt; array2[j]) <br/>
            &#123; <br/><br/>
                array3[k] = array1[i];<br/>
                i++;<br/>
            &#125;<br/>
 <br/>
 <code className='keywords'>   else </code><br/>
            &#123; <br/>
                array3[k] = array2[j];<br/>
                j++;<br/>
            &#125;<br/>
            k++;<br/>
        &#125;<br/>
 
        <code className='keywords'>  if</code> (i &gt;= m) <br/>
        &#123; <br/>
            while (j &lt; n) <br/>
            &#123; <br/>
                array3[k] = array2[j];<br/>
                j++;<br/>
                k++;<br/>
            &#125;<br/>
        &#125;<br/>
 
        <code className='keywords'>  if</code> (j &gt;= n) <br/>
        &#123; <br/>
        <code className='keywords'>    while</code>  (i &lt; m)<br/>
            &#123; <br/>
                array3[k] = array1[i];<br/>
                i++;<br/>
                k++;<br/>
            &#125;
        &#125;
 
        <code className='library'>  printf</code>("\n After merging: \n");<br/>
        for (i = 0; i &lt; m + n; i++) <br/>
        &#123; <br/>
        <code className='library'>     printf</code>("\n%d", array3[i]);<br/>
        &#125;<br/>
 <br/>
    &#125;<br/>
      </div>
        </div>

    )
}

export default Thirty_eight
